"use client";

import React from "react";
import GenericSubstantiveProcedures from "./substantive-procedures/GenericSubstantiveProcedures";

interface DynamicWorkspaceSubstantiveProps {
  area: "Planning" | "Execution" | "ConcludingProcedures";
  workspaceName: string;
  workspaceId: string;
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
}

export default function DynamicWorkspaceSubstantive({
  area,
  workspaceName,
  workspaceId,
  onBack,
  setActiveSection,
}: DynamicWorkspaceSubstantiveProps) {
  const landingKey = `dynamic-workspace:${area}:${workspaceId}:${encodeURIComponent(workspaceName)}`;

  const handleBack = onBack || (() => {
    if (setActiveSection) {
      setActiveSection(landingKey);
    }
  });

  return (
    <GenericSubstantiveProcedures
      workspaceName={workspaceName}
      area={area}
      onBack={handleBack}
      setActiveSection={setActiveSection}
    />
  );
}

